import { Type } from '../common';
import { IGraphic } from '../core/graphic';
import { IComponentOption } from '../interface/file';


/**
 * 组件元数据   包含组件名称/组件定义/组件调色板信息/以及组件初始化配置
 */
export interface IComponentMeta {
  id: string;
  graphicDef: Type<IGraphic>;
  paletteMeta?: IPaletteMeta; // 元数据，调色板依靠这些信息展示组件信息
  componentOption: IComponentOption;
}

/**
 * 调色板配置信息
 */
export interface IPaletteMeta {
  show?: boolean;
  displayName?: string;
  imageClass?: string;
  grabOption?: { // 组件被拖拽创建时的反馈信息
    width: number,
    height: number,
    backgroundImage: string
  };
}

export class ComponentMeta {
  constructor(private _meta: IComponentMeta) {
  }

  get id() {
    return this._meta.id;
  }

  get paletteMeta() {
    const paletteMeta = this._meta.paletteMeta;
    if (paletteMeta && paletteMeta.show) {
      const { displayName, imageClass, grabOption } = paletteMeta;
      return {
        id: this._meta.id,
        displayName, imageClass, grabOption,
      };
    } else {
      return null;
    }
  }

  get grabOption() {
    return this._meta.paletteMeta ? this._meta.paletteMeta.grabOption : null;
  }

  get componentOption() {
    return this._meta.componentOption;
  }

  get graphicDef() {
    return this._meta.graphicDef;
  }
}
